import { Component, Mixins, Prop, Ref } from 'vue-property-decorator';
import { AppFiltersMixin } from '@/mixins/AppFiltersMixin';
import { IHypotheekdeel } from '@/model/IHypotheekdeel';
import { BvModal } from 'bootstrap-vue';
import { AppHypotheekMixin } from '../../mixins/AppHypotheekMixin';
import { IBetaling } from '@/model/IBetaling';

@Component({})
export default class AppHypotheekdeelModal extends Mixins(AppFiltersMixin, AppHypotheekMixin) {
  @Prop()
  public hypotheekdeel!: IHypotheekdeel;
  @Prop()
  public canAflossen!: boolean;
  @Prop()
  public showAflossen!: boolean;
  @Prop()
  public showAflossenSpaarhypotheek!: boolean;

  public todo = '';

  @Ref('modal')
  private modal!: BvModal;

  public get isLevensverzekering(): boolean {
    return this.hypotheekdeel && this.hypotheekdeel.hypotheekvorm === 'Levensverzekering';
  }

  public get isSpaarhypotheek(): boolean {
    return this.hypotheekdeel && this.hypotheekdeel.hypotheekvorm === 'Spaarhypotheek';
  }

  public get betaling(): IBetaling | undefined {
    return this.hypotheek?.paidBetaling(this.hypotheekdeel);
  }

  public show() {
    this.modal.show('');
  }

  public close() {
    this.modal.hide('');
  }

  public goAflossen() {
    this.$emit('aflossen');
  }
}
